import styled, { css } from 'styled-components';

export const HeroBannerContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh; /* Full viewport height */
  overflow: hidden;
  color: white;
`;

export const BackgroundImage = styled.div<{ imageUrl: string }>`
  background: linear-gradient(
      to bottom, 
      rgba(0, 0, 0, 0.55),
      rgba(0, 0, 0, 0.45),
      rgba(0, 0, 0, 0.55)
    ),
    url(${props => props.imageUrl});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  position: absolute; /* Make sure the image fills the container */
  top: 0;
  left: 0;
`;

export const TextContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 3rem;
  width: 65%;
  transform: translateY(-50%);
  z-index: 2; /* Place above the background image */
  color: white;
  @media (max-width: 1050px) {
    width: 80%;
    left: 0;  
    padding: 1rem;
  }
  @media (max-width: 620px) {
    width: 90%;
  }
`;


export const Headline = styled.div`
  font-size: 6rem;
  font-weight: bold;
  @media (max-width: 1050px) {
    font-size: 2.75rem;
  }
`;

export const Content = styled.div`
  font-size: 1.5rem;
  margin-top: 1rem;
  @media (max-width: 1050px) {
    font-size: 1.25rem;
    margin-top: 0.5rem;
  }
`;

export const DownArrowButtonContainer = styled.div<{ hasButtonContainer: boolean }>`
  position: absolute;
  bottom: 3rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
`;


export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 3rem;
  right: 2rem;
  display: flex;
  z-index: 2;
  gap: 2rem;
  @media (max-width: 1050px) {
    display: none;
  }
`;